<template>
    <div class="download" style="background-color: #fff;">
        <div v-if="!onShow">
            <img src="../../assets/images/down.jpg">
        </div>
        <div v-if="onShow">
            <!-- <a href="#down">
                <img src="../../assets/images/down1.png">
            </a> -->
            <img src="../../assets/images/down1.png" @click="download">
            <img src="../../assets/images/down2.png">
            <img src="../../assets/images/down3.png">
            <img src="../../assets/images/down4.png">
            <img src="../../assets/images/down5.png">
            <img src="../../assets/images/down6.png">
            <!-- <img src="../../assets/images/download.png" style="width: 30%;padding: 30px 0 10px 0;">
            <div style="text-align: center;padding-bottom: 30px;">扫码下载APP</div> -->
        </div>
    </div>
</template>
<script>
    export default {
        name: 'template',
        data() {
            return {
                is_weixn:false,
                onShow:true
            }
        },
        methods: {
            download(){
                if(this.is_weixn){
                    this.onShow = false;
                }else{
                    this.onShow = true;
                    // window.open("https://www.pgyer.com/ylxsb");
                    if (/(iPhone|iPad|iPod|iOS)/i.test(navigator.userAgent)) {
                      //判断iPhone|iPad|iPod|iOS
                      window.open("https://apps.apple.com/cn/app/%E9%94%80%E5%94%AE%E4%BF%9D/id1525680624");
                    } else if (/(Android)/i.test(navigator.userAgent)) {
                      //判断Android
                      window.open("http://www.yiliangkeji.cn/static/app-xiaoshoubao-release.apk");
                    } else {
                      //pc
                    };
                }
            }
        },
        mounted(){
            var ua = navigator.userAgent.toLowerCase();
            if(ua.match(/MicroMessenger/i)=="micromessenger") {
                this.is_weixn = true;
            } else {
                this.is_weixn = false;
            }
        }
    }
</script>
<style>
    .download {

    }
    .download img {
        width: 100%;
        display: block;
        margin: 0 auto;
        padding: 0;
        border: none;
    }
</style>


// WEBPACK FOOTER //
// src/views/download/index.vue


// WEBPACK FOOTER //
// src/views/download/index.vue